import type { FinCategory } from '#dictionary'
import {
  LATEST_RATE_BY_REGION,
  RATE_BY_REGION_YEAR,
} from '#dictionary/realEstateRates'
import type { Region } from '#dictionary/regions'
import type { Nullable } from '#domain/types'
import MemberService from '#profile/MemberService'

import FinancialRecord, { type FinancialRecordPayload } from './FinancialRecord'

class RealEstateRecord extends FinancialRecord {
  public readonly realEstateTaxRate: Nullable<number>
  private readonly realEstateRegion: Nullable<Region>

  constructor(
    payload: FinancialRecordPayload,
    finCategory: FinCategory,
    owner: MemberService
  ) {
    super(payload, finCategory, owner)
    this.realEstateRegion = payload.realEstateRegion
    this.realEstateTaxRate = payload.realEstateTaxRate
  }

  override get region(): Region {
    return this.realEstateRegion ?? super.region
  }

  // Year-less "current growth rate" — semantically "latest published" for
  // the region, not a per-year lookup.
  override get growthRate(): number {
    const latestRate = LATEST_RATE_BY_REGION.get(this.region)?.growthRate
    return this.customGrowthRate ?? latestRate ?? super.growthRate
  }

  override getGrowthRateForYear(year: number): number {
    const exactMatch = RATE_BY_REGION_YEAR.get(this.region)?.get(
      year
    )?.growthRate
    return exactMatch ?? this.growthRate
  }
}

export default RealEstateRecord
